import { isWithinInterval } from 'date-fns';
import { DatesSummary } from '../entities';
import { weekdaysDateFilter } from './dates-filter';

export const availabilityClass =
  (summary: DatesSummary | null | undefined, membersCount: number | undefined) =>
  (date: Date): string => {
    const start = summary?.rangeCriteria?.start;
    const end = summary?.rangeCriteria?.end;

    if (!start || !end || !membersCount) return '';
    const availability = summary.groupResponses?.availability?.combinedAvailability;

    const isInRange = isWithinInterval(date, { start, end });
    const isAllowedDayOfWeek = weekdaysDateFilter(summary.rangeCriteria)(date);
    if (!availability || !isInRange || !isAllowedDayOfWeek) {
      return isInRange && isAllowedDayOfWeek ? 'availability empty' : '';
    }

    const count = availability[date.toISOString()];
    if (!count || count === 0) return 'availability empty';

    const percentage = (count / membersCount) * 100;

    if (percentage === 100) return 'availability full';
    const partial = Math.floor(percentage / 10) * 10;
    return partial !== 0 ? `availability partial-${partial}` : 'availability empty';
  };
